import {from} from './from'

import { writable } from 'svelte/store';

import { global } from './state.js'

let data = {
  type: "user",
  name: "...",
  description: "...",
  region: "eu-west-1",
  defaultCcy: "GBP",
  recs: [
  ],
  data: [
  ],
  teams: [
    // {
    //   id: "0",
    //   name: "Sample team",
    //   description: "Sample team description",
    //   recs: [],
    // },
  ],
  integrations: [
    {
      id: "0",
      type: "email",
      email: "sample@email.domain",
      run_success: true,
      run_failure: true,
      per_break: false,
    },
  ],
  apikeys: [
  ],
  modcount: 0,
};

export const settings = writable(data);

export function load(cb) {
  if (global.noauth) {
    return;
  }
  // load settings in dashboard call, vs here?
  from("/settings", {})
    .then((r) => r.json())
    .then(j => {
      console.log("loaded",j.settings)
      if (j.settings) {
        settings.set(j.settings)
        if (cb) {
          cb(j.settings);
        }
      }
    })
    .catch((ex) => {
      console.error("SettingsWidget - ex - ", ex, ex.stack);
    });
}

settings.subscribe(value => {
  data = value;
  // console.trace("settings - updated value", value);
});

export function save() {
  if (global.noauth) {
    return;
  }
  console.log("saving", data)
  from("/settings", { method: "POST", body: JSON.stringify(data) })
    .then((r) => r.json())
    .then((obj) => {
      console.log("saved"); // msg panel above main tabs? event to it? store subs?
    })
    .catch((ex) => {
      console.error("SettingsWidget - ex - ", ex, ex.stack);
    });
}